import hash from "../hash";
import getFacetLabel from "./facet_label";

const prepareFacetsGroup = (facets, facetGroup) => {
    const f = [];

    for (let facet in facets[facetGroup]) {
        const id = hash(facet + facetGroup, 'f');

        f.push({
            label: getFacetLabel(facet, facetGroup),
            name: facet,
            id: id,
            count: facets[facetGroup][facet],
            isLoading: false,
        });
    }

    return f;
};

export default prepareFacetsGroup